module.exports = __webpack_public_path__ + "static/header-4a0e3e31014cf250077ecea020c02990.png";